import axios from 'axios';
import { API_ROOT } from '../constants';
import { getLoggedInUser } from '../permissions';

/**
 * Sends a request to the centralized passthrough endpoint.
 *
 * @param {Object} options
 * @param {string} options.url - The relative URL/endpoint (e.g., '/booking/get?hospitalid=6')
 * @param {'cxServer' | 'c9usersMore'} options.app - The target app identifier
 * @param {'GET' | 'POST' } options.method - The HTTP method
 * @param {Object} [options.payload] - The request body/payload for POST
 * @returns {Promise<any>} The parsed response data
 */
export async function passthroughFetch({ url, app, method, payload }) {
  const requestUrl = `${API_ROOT}/api/passthrough`;

  const token = localStorage.getItem('token');
  const user = getLoggedInUser();
  const userRole = user && user.role;

  const response = await axios({
    method: 'POST',
    url: requestUrl,
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { authorization: `Bearer ${token}` } : {}),
      'x-role': userRole || ''
    },
    data: {
      url,
      app,
      method,
      payload
    }
  });

  return response.data;
}

export default passthroughFetch;
